<template>
    <div class="categories-donut-report">
        <div class="chart">
            <apexchart ref="chart" :height="height ? height : '500'" type="donut" :options="chartOptions" :series="data"></apexchart>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import "./styles.scss";

export default {
    props: ['period', 'height', 'dateFrom', 'dateTo'],

    components: {
        apexchart: VueApexCharts,
    },

    data: function() {
        return {
            transactions: [],

            categories: [],
            data: [],
            chartOptions: {
                legend: {
                    formatter: (name, {seriesIndex}) => {
                        return `<span class="category-name">${name}</span><span class="amount">${this.formatValue(this.data[seriesIndex])}</span>`;
                    }
                },
                plotOptions: {
                    pie: {
                        customScale: 0.8,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                tooltip: {
                    y: {
                        formatter: (value) => {
                            return this.formatValue(value);
                        }
                    }
                }
            },
        };
    },

    mounted() {
        this.load();
    },

    watch: {
        period: function() {
            this.load();
        },
        dateFrom: function() {
            this.load();
        },
        dateTo: function() {
            this.load();
        }
    },

    methods: {
        load() {
            axios.get(`/reports/categories?period=${this.period}&date_from=${this.dateFrom}&date_to=${this.dateTo}`)
                .then(({data}) => {
                    this.render(data);
                }).catch((error) => {
                    console.log(error);
                });
        },
        
        formatValue(value) {
            return this.$options.filters.money(value) + " ₴";
        },

        render(data) {
            this.transactions = data.data;

            this.categories = this.chartOptions.labels = Object.entries(data.data).map((a) => a[0]);
            this.$refs.chart.updateOptions({ labels: this.categories });
            
            this.data = Object.entries(data.data).map((a) => a[1].amount < 0 ? a[1].amount * -1 : a[1].amount);
        },
    }
}
</script>